// students/my-model
import {
  postData,
  postRequest,
} from 'src/services/RestApi';

export const apiCreate = async (payload) => {
  const formData = new FormData();
  if(payload.avatarField){
    formData.append('image', payload.avatarField, 'avatar.png');
  }

  const params = requestParams(payload);

  // console.log('==========', params);

  return await postRequest('api/student/create', formData, params, { isFormData: true });
};

export const apiUpdate = async (payload) => {
  const queryData = requestParams(payload, true);
  return await postData('api/student/edit', queryData);
};


function requestParams(values, isCreate = false) {
  const queryData = {};
  if (!isCreate) {
    queryData.accountId = values.id;
  }

  if (values.nameField || isCreate) {
    queryData.name = values.nameField;
  }
  if (values.phoneField || isCreate) {
    queryData.phone = values.phoneField;
  }
  if (values.degreeId || isCreate) {
    queryData.degreeId = values.degreeId;
  }
  if (values.partnerId || isCreate) {
    queryData.partnerId = values.partnerId;
  }

  if (values.emailField) {
    queryData.email = values.emailField;
  }
  if (values.addressField) {
    queryData.address = values.addressField;
  }
  if (values.idCardField) {
    queryData.idCard = values.idCardField;
  }
  if (values.birthdayField) {
    queryData.birthday = values.birthdayField;
  }
  if (values.genderId) {
    queryData.genderId = values.genderId;
  }
  if (values.note) {
    queryData.note = values.note;
  }

  if (values.contactField) {
    queryData.contact = values.contactField;
  }
  if (values.groupId) {
    queryData.groupId = values.groupId;
  }
  // if (values.primaryField) {
  //   queryData.primaryCode = values.primaryField;
  // }
  // if (values.secondaryField) {
  //   queryData.secondaryCode = values.secondaryField;
  // }
  
  return queryData;
}